export const templateSelectorName = 'template';
